/**
 * file
 *
 * @author Shigq
 * @date 2021/6/22 11:43
 */
import { gateway } from '@/config'
import { getFilePath } from "@/api/modules/common"
import { joinFile } from "@/utils"
import { useI18n } from "@/plugins/i18n"

const { sr: { locale } } = useI18n()

export default function() {
  const scopedStatic = {
    template: {
      certOfAuth: joinFile('auth/auth.pdf', true),
      idCardFront: require('@/assets/img/components/sr-upload/id-card-front.png'),
      idCardBack: require('@/assets/img/components/sr-upload/id-card-back.png'),
      idCardHold: require('@/assets/img/components/sr-upload/id-card-hold.png'),
      businessBr: require('@/assets/img/components/sr-upload/香港CI.jpg'),
      businessSr: require('@/assets/img/components/sr-upload/香港SR.jpg'),
      passport: require('@/assets/img/components/sr-upload/passport.png'),
      HKAndMOPassFront: require('@/assets/img/components/sr-upload/HK-and-MO-pass-front.png'),
      HKAndMOPassBack: require('@/assets/img/components/sr-upload/HK-and-MO-pass-back.png'),
      bizLicense: require('@/assets/img/components/sr-upload/biz-license.png'),
      serviceProtocol: joinFile(`auth/SUNRATE Referral Programme Partnership Agreement[${locale}].pdf`, true),
      bizIntAgreement: joinFile(`auth/Business Introduction Agreement[${locale}].docx`, true),
      memberProtocol: joinFile(`auth/Terms of Service[${locale}].pdf`, true),
      privacyProtocol: joinFile(`auth/Privacy Policy[${locale}].pdf`, true),
      authPdf: joinFile(`auth/auth[${locale}].pdf`, true),
    }
  }

  const scopedMethods = {
    /**
     * file type
     *
     * @param file
     * @returns {string}
     */
    getFileType: (file) => {
      let suffix = file.url ?
        file.url.substr(file.url.lastIndexOf('.') + 1) :
        file.name.substr(file.name.lastIndexOf('.') + 1)

      if (suffix) {
        suffix = suffix.toLowerCase()
      }

      return suffix
    },
    /**
     * file to base64
     *
     * @param file
     * @returns {Promise<unknown>}
     */
    fileToBase64: async (file) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      return new Promise((resolve, reject) => {
        reader.onload = function() {
          if (reader.result) {
            resolve(reader.result)
          } else {
            reject(new Error('fileToBase64###exception'))
          }
        }
      })
    },
    getFileRemoteUrl: async (fileId, userId) => {
      const { url } = await scopedMethods.getFileRemoteInfo(fileId, userId)
      return url
    },
    getFileRemoteInfo: async (fileId, userId) => {
      const param = { fileId, userId }
      const { fileUrl, fileName } = await getFilePath(param)
      return { url: fileUrl, fileName }
    }
  }

  return {
    ...scopedStatic,
    ...scopedMethods
  }
}
